import React, {useState} from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import logo from '../assets/images/industry_mark.svg'
import logoONE from '../assets/images/industry_one_mark.png'

const SiteHeader = styled.header`
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    padding-top: 2rem;
    z-index: 9999;
    pointer-events: none;
    .header-contain {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    #nav-item-2 {
        min-width: 8.666rem;
    }
    #nav-item-3 {
        min-width: 9.2rem;
    }
    #nav-item-4 {
        min-width: 8rem;
    }
    #nav-item-5 {
        min-width: 10rem;
        img {
            width: 7rem;
        }
    }
    .header-nav-lg span {
        display: inline-block;
        text-align: right;
    }
    .header-nav-lg a {
        text-decoration: none;
        font-size: 0.9rem;
        letter-spacing: 0.25px;
        font-family: "neue-haas-unica", serif;
        font-weight: 100;
        pointer-events: auto;
        &:hover {
            font-family: "Ogg-Roman", serif;
        }
    }
    .header-nav-sm {
        display: none;
        pointer-events: auto;

    }
    .header-nav-lg {
        display: block;
    }   
    .header-mark {
        pointer-events: auto;
    }
    @media all and (max-width: 1024px) {
        .header-nav-lg {
            display: none;
        }
        .header-nav-sm {
            display: block;
            z-index: 2
        }
    }
`

const SmallMenu = styled.div`
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: white;
        opacity: 0;
        transition: opacity .2s ease-in-out, z-index .2s ease-in-out;
        z-index: -1;
        &.is_active {
            opacity: 1;
            z-index: 999;
        }
        .sm-menu-primary {
            display: flex;
            height: 100%;
            width: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .sm-menu-link {
                display: block;
                text-decoration: none;
                letter-spacing: .25px;
                font-size: 1.5rem;
                font-family: "neue-haas-unica",serif;
                font-weight: 100;
                margin-bottom: 1.33rem;
                width: 100%;
                text-align: center;
                &:hover {
                    font-family: "Ogg-Roman", serif;
                }
                &.ind-one-link {
                    padding-top: 1rem;
                    img {
                        width: 180px;
                    }
                }
            }
        }
        @media all and (min-width: 1025px) {
             &.is_active {
                opacity: 0;
                z-index: -1;
            }
        }

`

const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
    const handleClick_hamburger = (e) => {
        setShowMenu(!showMenu)
    }
    return (
        <>
            <SiteHeader>
                <div className="full-w-contain header-contain">

                    <div className="header-mark">
                        <Link to="/"><img src={logo} alt="INDUSTRY" /></Link>
                    </div>

                    <div role="navigation" aria-label="Main menu" className="header-nav header-nav-lg">
                        <span id="nav-item-1"><Link to="/what-we-do">What We Do</Link></span>
                        <span id="nav-item-2"><Link to="/how-we-do-it">How We Do It</Link></span>
                        { //<span id="nav-item-3"><Link to="/what-we-learn">What We Learn</Link></span>
                        } 
                        <span id="nav-item-4"><Link to="/who-we-are">Who We Are</Link></span>
                        <span id="nav-item-5"><Link to="https://www.industry1.org"><img src={logoONE} alt="INDUSTRY ONE" /></Link></span>
                    </div>

                    <div className="header-nav-sm">              
                        <button onClick = {() => handleClick_hamburger()} className={`hamburger hamburger--squeeze ${showMenu ? 'is-active' : ''}`} id="hamburger" type="button">
                            <span aria-hidden="true" focusable="false" className="hamburger-box">
                                <span aria-hidden="true" focusable="false" className="hamburger-inner"></span>
                            </span>
                        </button>
                    </div>

                </div>
            </SiteHeader>

            <SmallMenu className={`sm-menu ${showMenu ? 'is_active' : ''}`}>
                <div className="sm-menu-primary">
                    <Link className="sm-menu-link"  onClick = {() => handleClick_hamburger()} to="/what-we-do">What We Do</Link>
                    <Link className="sm-menu-link"  onClick = {() => handleClick_hamburger()} to="/how-we-do-it">How We Do It</Link>
                    {//<Link className="sm-menu-link"  onClick = {() => handleClick_hamburger()} to="/what-we-learn">What We Learn</Link>
                    }
                    <Link className="sm-menu-link"  onClick = {() => handleClick_hamburger()} to="/who-we-are">Who We Are</Link>
                    <Link className="sm-menu-link ind-one-link" to="https://www.industry1.org"><img src={logoONE} alt="INDUSTRY ONE" /></Link>
                </div>
            </SmallMenu>
        </>
    )
}

export default Header
